module.exports = __webpack_public_path__ + "static/media/collapse.3360873c.svg";